resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function APIRequest (url, type, data, callback, requestOptions, localStoreBool, locale) {
  // Parameters
  this.callback = function (responseData, statusCode) {};
  // default polling interval is hard coded to 0.5 s
  this.pollingInterval = 500;
  // default timeout is card coded to 30 s
  this.pollingTimeout = 30000;

  this.timedOut = false;
  this.pollingTimeoutId = null;

  this.transactionId = null;
  this.complete = false;
  this._url = null;
  this._type = null;
  this._data = null;
  this._locale = null;
  this._timerId = null;
  this._timedOutRequest = null;
  this._errored = null;

  this._paths = new _Secured();
  this._session = new Session();
  this.localStoreBool = false;
  this._localStore = new LocalStore();
  this._isStoreValid = false;

  // Constants
  this._ACCEPT_HEADER = mogo.registry.mogoUI.config.apiAcceptHeader;
  this._X_CLIENT_HEADER = mogo.registry.mogoUI.config['X-Mogo-Client'];

  this.constructor = function (url, type, data, callback, requestOptions, localStoreBool, locale) {

    if (typeof callback === 'function') this.callback = callback;
    // parsing requestOptions
    // options from BE takes the first priority.
    // filter out 0, null, '' values
    if (
      requestOptions &&
      requestOptions.polling_interval &&
      requestOptions.polling_timeout &&
      !isNaN(requestOptions.polling_interval) &&
      !isNaN(requestOptions.polling_timeout)
    ) {
      this.pollingInterval = requestOptions.polling_interval * 1000;
      this.pollingTimeout = requestOptions.polling_timeout * 1000;
    // backwards compatible, still allow an interval number
    } else if (
      requestOptions &&
      !isNaN(requestOptions)
    ) {
      this.pollingInterval = requestOptions;
      this.pollingTimeout = requestOptions * 30; // adjust timeout value based on interval (e.g. when interval = 6000 (6s), timeout would be 6000 * 30 (180s))
    }

    this._url = url;
    this._type = type;
    this._data = data;
    this._locale = locale;
    this.localStoreBool = localStoreBool || this.localStoreBool;
    this.mockService = window.mogo.registry.mogoUI.config.mockServiceConfigs
      ? new MockService(window.mogo.registry.mogoUI.config.mockServiceConfigs) : null;

    var cacheBustDate = new Date();
    var cacheBustLength = 13;
    cacheBustDate.setDate(cacheBustDate.getDate() + cacheBustLength);

    if (
      this._localStore.store.hasOwnProperty('requests') &&
      this._type === 'GET' &&
      this._localStore.store.requests.hasOwnProperty(this._url) &&
      this._localStore.store.requests[this._url].version === window.mogo.registry.mogoUI.version &&
      this._localStore.store.requests[this._url].timestamp < cacheBustDate
    ) {
      this._isStoreValid = true;
    }
  };

  this._storeRequestResults = function (responseData) {
    this._localStore.store.requests = this._localStore.store.requests
      ? this._localStore.store.requests
      : {};

    this._localStore.store.requests[this._url] = {
      responseData: responseData,
      version: window.mogo.registry.mogoUI.version,
      timestamp: Date.now()
    };

    this._localStore.save();
  };

  this.send = function (url, type, data, locale) {
    if (this._isStoreValid) {
      this.callback(this._localStore.store.requests[this._url].responseData, 200, this);
      return;
    }
    url = url || this._url;
    type = type || this._type;
    if (data === undefined) data = this._data;
    locale = locale || this._locale;
    
    this._timedOutRequest = null;
    this._errored = null;

    var params = new Object();
    params['url'] = url;
    params['type'] = type;
    params['headers'] = new Object();
    params['headers']['Accept'] = this._ACCEPT_HEADER;
    params['headers']['Content-Type'] = 'application/json';
    params['headers']['X-Auth-Token'] = this._session.getAuthToken();
      params['headers']['X-Bearer-Token'] = this._session.getBearerToken();
    params['headers']['X-Mogo-Client'] = mogo.registry.mogoUI.config['X-Mogo-Client'];
    params['cache'] = false;
    params['dataType'] = 'json';
    params['success'] = this._onRequestSuccess.bind(this);
    params['error'] = this._onRequestError.bind(this);

    // Is MockService Profiling Mode running?
    if (this.mockService && this.mockService.mockServiceRuntime.run) {
      this.parameterizedUrl = url;
      if (data != null && type === 'GET') {
        this.parameterizedUrl = this.parameterizedUrl + '?' + jQuery.param(data);
      }
      if (this.mockService.ifPatternMatch(this.parameterizedUrl, type)) {
        var mockFilePath = this.mockService.getMockFilePath(this.parameterizedUrl, type);
        if (mockFilePath) {
          params['headers']['Accept'] = '*/*';
          params['url'] = mockFilePath;
          params['type'] = 'GET';
        } else if (this.mockService.hasMockData(this.parameterizedUrl, type)) {
          var mockData = this.mockService.getMockData(this.parameterizedUrl, type);
          setTimeout(function (md, ts, r) {
            this._onRequestSuccess(md, ts, r);
          }.bind(this, mockData, 'success', {status: 200, responseJSON: mockData}), 100);
          return;
        }
      }
    }

    if (data != null) {
      if (params['type'] == 'GET') {
        params['data'] = typeof data === 'string' ? data : jQuery.param(data);
      } else {
        params['data'] = JSON.stringify(data);
      }
    }

    if (locale != null && typeof locale === 'string') {
      params['headers']['Accept-Language'] = locale; // 'fr-CA'
    }

    $.ajax(params);
    this._timerId = null;
    // not using === intentionally since the value could be null or undefined.
    if (this.pollingTimeoutId == null) {
      this.pollingTimeoutId = setTimeout(function () {
        this.timedOut = true;
      }.bind(this), this.pollingTimeout);
    }
  };

  this.retry = function () {
    if (!this._timedOutRequest && !this._errored) {
      return false;
    }

    if (this._timedOutRequest) {
      this.send(this._timedOutRequest.url, 'GET', null);
      this._timedOutRequest = null;
    } else {
      this.send();
      this._errored = null;
    }

    this._timerId = null;
    return true;
  };

  this.continuePolling = function () {
    this._timerId = setTimeout(this.send.bind(this, this._currentPollingUrl, 'GET', null), this.pollingInterval);
  };

  this.cancel = function () {
    if (this._currentPollingUrl) {
      this._timedOutRequest = {
        url: this._currentPollingUrl
      };
    } else {
      this._errored = true;
    }

    this._timerId = clearTimeout(this._timerId);
    this.pollingTimeoutId = clearTimeout(this.pollingTimeoutId);
  };

  this._onRequestSuccess = function (responseData, textStatus, response) {
    if (response.status == '202') {
      this._currentPollingUrl = responseData.polling_url || null;
      if (!this.timedOut) {
        // Polling URL
        if (this._currentPollingUrl != null) {
          this.transactionId = this._currentPollingUrl.substring(this._currentPollingUrl.indexOf('trans/') + 6);
          this.continuePolling();
        }
      } else {
        this._timedOutRequest = {
          url: this._currentPollingUrl
        };
        this.callback(
          {
            errors: [
              {property: 'http_service', key: 'client_polling_timeout_client', uri: this._currentPollingUrl}
            ]
          },
          408,
          this
        );
      }
      return;
    } else {
      this._timerId = null;
      this.pollingTimeoutId = clearTimeout(this.pollingTimeoutId);
      if (this.mockService && this.mockService.mockServiceRuntime.run && this.mockService.ifPatternMatch(this.parameterizedUrl, type) && this.mockService.hasUpdateProperties(this.parameterizedUrl, type)) {
        this.callback(this.mockService.updateMockResponse(this.parameterizedUrl, type, responseData), '200', this);
      } else if (this.callback) {
        this.callback(responseData, response.status, this);
      }

      if (this.localStoreBool) this._storeRequestResults(responseData);
    }
    this.complete = true;
  };

  this._onRequestError = function (response, textStatus, error) {
    this._timerId = null;
    this.pollingTimeoutId = clearTimeout(this.pollingTimeoutId);
    if (response.status == 401) {
      if (
        response.responseJSON &&
        response.responseJSON.errors[0].key == 'incorrect_email_address_or_password'
      ) {
        this.callback(response.responseJSON, response.status, this);
      } else {
        this._session.deleteAuthToken();
        this._session.deleteBearerToken();
        this._session.deleteRefreshToken();

        if (location.pathname.indexOf(this._paths._SECURED_DOMAIN) === 0) {
          var trackingParam = getURLParameter('tracking').trim(0);
          var trackingString = trackingParam ? '?tracking=' + trackingParam : '';
          window.location.replace(this._paths._LOGIN_PATH + trackingString);
        }
      }
    } else if (this.callback) {
      this._errored = true;
      this.callback(response.responseJSON, response.status, this);
    }
  };

  this.constructor(url, type, data, callback, requestOptions, localStoreBool, locale);
}
